export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // This catch block handles potential Same-Origin Policy errors
    // if the iframe content is from a different origin than the parent.
    // In such cases, if access to window.top is blocked, we can assume it's in an iframe.
    return true;
  }
};
